import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import {Getstarted} from '../../../components/essentials/get-started/getstarted.component';

import phoneImg from '../../../assest/26-Digital Credentials/Description_Section_Resized.png';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import photoOnPhone from '../../../assest/26-Digital Credentials/howsolwoks.png'
import benefits from '../../../assest/26-Digital Credentials/EOTY.png'
import './digital-credentials.scss';
//import { OverlapBoxTechno } from '../../technopage/techno.component';
import {  OverlapBoxFeature } from '../features-page/features-page.component';

import education from '../../../assest/26-Digital Credentials/icons/education.png';
import profOrg from '../../../assest/26-Digital Credentials/icons/prof orgs.png';
import workforce from '../../../assest/26-Digital Credentials/icons/workforce.png';
import vital from '../../../assest/26-Digital Credentials/icons/vital records.png';
import health from '../../../assest/26-Digital Credentials/icons/health records.png';
import finance from '../../../assest/26-Digital Credentials/icons/fin creds.png';
import govId from '../../../assest/26-Digital Credentials/icons/gov ids.png';
import membership from '../../../assest/26-Digital Credentials/icons/membership.png';

import complaint from '../../../assest/25 - Age Verification/icons/compliant.png';
import privacy from '../../../assest/25 - Age Verification/icons/privacy preserving.png';
import seamless from '../../../assest/25 - Age Verification/icons/seamless integration.png';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';
// import global from '../../../assest/25 - Age Verification/global coverage.png'
// import dataAnalytics from '../../../assest/25 - Age Verification/9624 man.png'

//import {  MediumCard } from '../platformpage/platform.component';
//import { OverlapBox } from '../../../components/essentials/overlap-box/overlap-box.component';

export const DigitalCredentials = () => {
   const { t } = useTranslation('digitalCredentials');
return(
<div className='blogs-main'>
    <NavBar />
    <HeaderHalf title='Verifiable Digital Credentials' uris='Verifiable Digital Credentials' />

    <OverlapBoxTechno
  img={phoneImg}
  title={t('title')}
>
  <TrackedSection sectionName="DigitalCredPage Management">
    <p>{t('section1Para1')}</p>
    <p>{t('section1Para2')}</p>
    <p>{t('section1Para3')}</p>
    <p>{t('section1Para4')}</p>
  </TrackedSection>
</OverlapBoxTechno>

<OverlapBoxFeature title={t('howItWorksTitle')}>
  <TrackedSection sectionName="DigitalCredPage SolutionWorks">
    <p className='industries-text'>
      {t('solutionWorksPara')}
    </p>
    <div>
      <img src={photoOnPhone} className='kys-platform-imagee1' alt='MoreCardIcon' />
    </div>
    <MoreBox />
  </TrackedSection>
</OverlapBoxFeature>

<OverlapBoxIndustry title={t('industryUseCasesTitle')} className='overlap-box-industry'>
  <TrackedSection sectionName="DigitalCredPage Industry">
    <p className='industries-text'>
      {t('industryIntroPara')}
    </p>
    <div className='cards-div-industries'>
      <LargeCard
        img={education}
        title={t('industryCards.education.title')}
        desc={t('industryCards.education.desc')}
      />
      <LargeCard
        img={profOrg}
        title={t('industryCards.professionalOrgs.title')}
        desc={t('industryCards.professionalOrgs.desc')}
      />
      <LargeCard
        img={workforce}
        title={t('industryCards.workforce.title')}
        desc={t('industryCards.workforce.desc')}
      />
      <LargeCard
        img={vital}
        title={t('industryCards.vitalRecords.title')}
        desc={t('industryCards.vitalRecords.desc')}
      />
      <LargeCard
        img={health}
        title={t('industryCards.healthRecords.title')}
        desc={t('industryCards.healthRecords.desc')}
      />
      <LargeCard
        img={finance}
        title={t('industryCards.financial.title')}
        desc={t('industryCards.financial.desc')}
      />
      <LargeCard
        img={govId}
        title={t('industryCards.govIDs.title')}
        desc={t('industryCards.govIDs.desc')}
      />
      <LargeCard
        img={membership}
        title={t('industryCards.memberships.title')}
        desc={t('industryCards.memberships.desc')}
      />
    </div>
  </TrackedSection>
</OverlapBoxIndustry>


      <OverlapBoxFeature  title='Solution Benefits'>
      <TrackedSection sectionName="DigitalCredPage SolutionBenefits">
        <EarthidBox />
        </TrackedSection>
      </OverlapBoxFeature>

      <OverlapBoxFeature title={t('trustSection.title')}>
      <TrackedSection sectionName="DigitalCredPage Trust">
        <div className='platform-content'>
          <p className='cards-div-title'>
            {t('trustSection.subtitle')}
          </p>
          <div className='cards-div-platform'>
            <MediumCard
              icon={complaint}
              title={t('trustSection.cards.0.title')}
              desc={t('trustSection.cards.0.desc')}
            />
            <MediumCard
              icon={privacy}
              title={t('trustSection.cards.1.title')}
              desc={t('trustSection.cards.1.desc')}
            />
            <MediumCard
              icon={seamless}
              title={t('trustSection.cards.2.title')}
              desc={t('trustSection.cards.2.desc')}
            />
          </div>
        </div>
      </TrackedSection>
    </OverlapBoxFeature>
      {/* <SectionRight
        title="Global Coverage"
        title1="11K+ Documents Supported"
        content1= "EarthID supports over 11,500 identity documents from more than 230 countries and territories. Our extensive global reach allows you to verify your user's age from anywhere in the world."
        
        title2="45+ Languages and Dialects Supported"
       content2= "We have tailored our end-user flows to cater to the world's largest markets, providing support for 45+ languages and dialects. By offering a wide range of languages, we ensure that we can serve a diverse customer base. Our commitment to expanding our language offerings helps us meet the strategic goals of our partners."
        imgPath={global}
      ></SectionRight>
      <SectionLeft
        title="Advanced Security Measures"
        title1="Device and Network Analytics"
        content1= "As part of our comprehensive fraud prevention measures, EarthID analyzes the device and network used during a verification session, assigning each a unique fingerprint. This, along with hundreds of other parameters and checks for inconsistencies in personal data on the ID, ensures a robust verification process before delivering results."
        
        title2="Liveness Detection"
       content2= "EarthID&apos;s advanced liveness detection technology determines if a session or user is real or a spoof attempt, all without requiring extra steps from your customers. This seamless process enhances security while maintaining a smooth user experience."
        imgPath={dataAnalytics}
      ></SectionLeft> */}
    <Getstarted/>
    <Footer />
  </div>
)
  
}

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-distributeevc'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
        Solutions / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};

const MoreBox = () => {
  const { t } = useTranslation('digitalCredentials');

  const cards = t('moreBox.cards', { returnObjects: true });

  return (
    <div className='kys-div'>
      <div className='kys-platform-content'>
        {cards.slice(0, 4).map((card, idx) => (
          <KYSCard key={idx} icon={kysBulletPoint} title={card.title} desc={card.desc} />
        ))}
      </div>
      <div className='kys-platform-content'>
        {cards.slice(4).map((card, idx) => (
          <KYSCard key={idx + 4} icon={kysBulletPoint} title={card.title} desc={card.desc} />
        ))}
      </div>
    </div>
  );
};

  const OverlapBoxIndustry = props => {
    return (
      <div className='overlap-boxx'>
        <p className='box-title'>{props.title}</p>
        {props.children}
      </div>
    );
  };

  const LargeCard = ({ img, desc, title }) => {
    return (
      <div className='large-card'>
        <img src={img} className='large-card-imgg' alt='largeCardImg' />
        <p className='large-card-title'>{title}</p>
        <p className='large-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    );
  };

  const EarthidBox = () => {
    const { t } = useTranslation('digitalCredentials');
  
    // Safely extract array or fallback to empty array
    const cards = t('earthidBox.cards', { returnObjects: true }) || [];
  
    return (
      <div className='kys-div'>
        <div className='kys-platform-content'>
          {Array.isArray(cards) &&
            cards.slice(0, 5).map((card, index) => (
              <KYSCard key={index} icon={kysBulletPoint} title={card.title} desc={card.desc} />
            ))}
        </div>
        <div className='kys-platform-content'>
          {Array.isArray(cards) &&
            cards.slice(5).map((card, index) => (
              <KYSCard key={index + 5} icon={kysBulletPoint} title={card.title} desc={card.desc} />
            ))}
        </div>
        <div className='kys-platform-img'>
          <img src={benefits} className='kys-platform-imagee' alt='kysCardIcon' />
        </div>
      </div>
    );
  };


  // const SectionRight = props => {
  //   return (
  //     <div className='feature-box-right'>
  //       <p className='title-feature'>{props.title}</p>
  //       <div className="display-flex">
  //         <div className='feature-box-content'>
  //           <div className='overallcontent'>
  //           <p className='title1-feature'>{props.title1}</p>
  //         <p className='content1-feature'>{props.content1}</p>
  //         <p className='title1-feature'>{props.title2}</p>
  //         <p className='content1-feature'>{props.content2}</p>
  //           </div>
          
  //         </div>
  //         <div className='feature-box-image'>
  //           <img src={props.imgPath} />
  
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // const SectionLeft = props => {
  //   return (
  //     <div className='feature-box-left'>
  //       <p className='title-feature'>{props.title}</p>
  //       <div className="display-flex">
  //       <div className='feature-box-image'>
  //           <img src={props.imgPath} />
  
  //         </div>
  //         <div className='feature-box-content'>
  //           <div className='overallcontent'>
  //           <p className='title1-feature'>{props.title1}</p>
  //         <p className='content1-feature'>{props.content1}</p>
  //         <p className='title1-feature'>{props.title2}</p>
  //         <p className='content1-feature'>{props.content2}</p>
  //           </div>
          
  //         </div>
          
  //       </div>
  //     </div>
  //   );
  // };

 const KYSCard = ({ icon, desc, title }) => {
    return (
      <div className='kys-card'>
        <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
        <div className="key-text-col">
          <p className='kys-card-title'>{title}</p>
          <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
        </div>
      </div>
    );
  };

 const OverlapBoxTechno = ({ img, title, children }) => {
    return (
      <div className='overlap-box-technoo'>
        <img src={img} alt='phone-img' className='techno-img' />
        <div className='techno-content'>
          <p className='techno-title'>{title}</p>
          <div className='rest-para'>{children}</div>
        </div>
      </div>
    );
  };


  const MediumCard = ({ icon, desc, title }) => {
    return (
      <div className='medium-card'>
        <img src={icon} className='medium-card-icon-platform' alt='mediumCardIcon' />
        <p className='medium-card-title'>{title}</p>
        <p className='medium-card-desc-platform'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    );
  };